<template>
    <vx-card :title="pageTitle" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4 mb-1">
                <label class="vs-input--label"> Интервал </label>
                <date-picker
                    range
                    v-model="dateInterval"
                    type="datetime"
                    format="YYYY-MM-DD-HH:mm:ss"
                    placeholder="Интервал времени события"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input
                    v-model="form.sourceId"
                    autocomplete="off"
                    label="ID источника"
                    placeholder="Введите ID источника..."
                    class="mt-1 w-full"/>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <vs-input
                    v-model="form.siteId"
                    autocomplete="off"
                    label="ID сайта"
                    placeholder="Введите ID площадки..."
                    class="mt-1 w-full"/>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-full mb-1">
                <div>
                    <vs-button color="success" @click="loadData(true)" type="filled"> Получить </vs-button>
                </div>
            </div>
        </div>

        <div>
            <vs-table :data="items" :max-items="pageSize" stripe @sort="handleSort" :sst="true" class="mt-5">
                <template slot="thead">
                    <vs-th sort-key="kaminary_cnt"> Обращений к каминари</vs-th>
                    <vs-th sort-key="redis_cnt"> Проверок через редис </vs-th>
                    <vs-th sort-key="bot_cnt"> Проверок с признаком бот </vs-th>
                    <vs-th sort-key="total_cnt"> Всего обращений </vs-th>
                </template>

                <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>{{ tr.kaminaryCount }} ({{ tr.kaminaryPercent | formatNumber(2) }}%)</vs-td>
                        <vs-td>{{ tr.redisCount }} ({{ tr.redisPercent | formatNumber(2) }}%)</vs-td>
                        <vs-td>{{ tr.botCount }} ({{ tr.botPercent | formatNumber(2) }}%)</vs-td>
                        <vs-td>{{ tr.totalCount }}</vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <vs-pagination :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination> 
        </div>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import DatePicker from 'vue2-datepicker';
import qs from 'qs';
import axios from 'axios';

export default {
    name: 'antifrod-metrics',
    data() {
        return {
            pageTitle: 'Метрики фрода',
            items: [],
            dateInterval: undefined,
            form: {
                sourceId: undefined,
                siteId: undefined,
                date_time_from: undefined,
                date_time_to: undefined,
                orderBy: undefined,
                isAscOrder: undefined
            },
            dicts: {
            },
            page: 1,
            pageSize: 200,
            pagesTotal: 1,
        };
    },
    mounted() {
        this.setDefaultValues();
        this.loadData();
    },
    methods: {
        loadData(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            const params = {
                sourceId: this.form.sourceId,
                siteId: this.form.siteId,
                dateFrom: this.form.date_time_from,
                dateTo: this.form.date_time_to,
                orderBy: this.form.orderBy,
                isAscOrder: this.form.isAscOrder,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('antifrod/metrics', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    }),
                    this.axios.get('antifrod/metrics/count', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params);
                        }
                    })
                ])
                .then(
                    axios.spread((items, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.items = items.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки метрик.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },

        handleSort(key, active) {
            this.form.orderBy = key;
            this.form.isAscOrder = active == 'asc';

            this.loadData();
        },

        setDefaultValues() {
            let endDay = this.$moment(new Date());
            let endDayStr = endDay.format('YYYY-MM-DD ');
            let startDay = endDay.add(-1, 'days');
            let startDayStr = startDay.format('YYYY-MM-DD ');
            let startTime = '00:00:00';
            let endTime = '23:59:59';
            this.dateInterval = [startDayStr + startTime, endDayStr + endTime];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker
    },
    watch: {
        page: function () {
            this.loadData();
        },
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD HH:mm:ss');
        }
    }
};
</script>

<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

thead {
    th {
        font-size: 15px !important;

        .sort-th {
            i {
                font-size: 19px;
            }
        }
    }
}
.vs-con-table .vs-con-tbody, .vs-table--content {
    overflow: initial;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
}

.header-title {
    flex-direction: column;
}

.textarea {
    border: 1px solid lightgrey !important;
    background-color: RGB(245, 245, 245);
}
.date-p {
    display: block;
}
.b-btn {
    border-radius: 0;
    width: 200px;
}
.vs-pagination--mb {
    justify-content: center !important;
}

.status-col {
    min-width: 190px;
}

.logs-popup .vs-popup {
    width: 1000px;
}
</style>

<style scoped>
th >>> div {
    float: right;
}

tr >>> .vs-table--td {
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px;
}
</style>